import type { TranslationMessages } from '../types';

export const menus: TranslationMessages = {
        title: 'Menu',
        subtitle: 'Quản lý menu sản phẩm của bạn',
        loading: 'Đang tải menu...',
        new_menu: 'Menu mới',
        search_placeholder: 'Tìm kiếm menu...',
        no_menus: 'Chưa có menu nào. Tạo menu đầu tiên của bạn!',
        no_results: 'Không tìm thấy menu',
        load_error: 'Không thể tải menu',
        delete_confirm: 'Bạn có chắc chắn muốn xóa menu này không?',
        delete_error: 'Không thể xóa menu',
        menu_details: 'Chi tiết Menu',
        name_placeholder: 'Nhập tên menu',
        description_placeholder: 'Nhập mô tả menu (tùy chọn)',
        edit_subtitle: 'Chỉnh sửa cấu hình menu',
        create_subtitle: 'Tạo menu mới',
        save_error: 'Không thể lưu menu',
        select_categories: 'Chọn Danh mục',
        exclude_products: 'Bỏ chọn sản phẩm để loại trừ chúng khỏi menu này:',
        products: 'sản phẩm',
        no_categories: 'Chưa có danh mục nào. Vui lòng tạo danh mục trước.',
        active: 'Hoạt động',
        categories_count: 'Danh mục',
        menus: 'menu',
        exclude_categories: 'Loại trừ Danh mục',
        exclude_categories_description:
          'Loại trừ sản phẩm từ các danh mục cụ thể khỏi menu này (ví dụ: loại trừ danh mục "Dịch vụ" khỏi menu Dịch vụ)',
        exclude_category_label: 'Loại trừ danh mục "%{name}"',
        excluding_categories: 'Đang loại trừ danh mục: %{names}',
      };
